import { cartStore } from '@stores/cart';

export function useCart() {
    // Sélecteurs optimisés pour éviter les re-renders globaux
    const byouCart = cartStore((state) => state.byouCart);
    const updateCartOptions = cartStore((state) => state.updateCartOptions);
    const updateCart = cartStore((state) => state.updateCart);
    const addDeliveryMode = cartStore((state) => state.addDeliveryMode);
    const removeDeliveryMode = cartStore((state) => state.removeDeliveryMode);
    const consent = cartStore((state) => state.consent);
    const setConsent = cartStore((state) => state.setConsent);

    return { byouCart, updateCartOptions, updateCart, addDeliveryMode, removeDeliveryMode, consent, setConsent };
}
